;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export type Season = "Spring" | "Summer" | "Fall" | "Winter"

/** Meteorological Northern Hemisphere: monthIndex is Date#getMonth() (0–11). */
export function getSeasonFromMonth(monthIndex: number): Season {
  if (monthIndex === 11 || monthIndex <= 1) return "Winter"
  if (monthIndex <= 4) return "Spring"
  if (monthIndex <= 7) return "Summer"
  return "Fall"
}

export function getCurrentSeason(date: Date = new Date()): Season {
  return getSeasonFromMonth(date.getMonth())
}
